import RepsolLayoutLoginComponent from './RepsolLayoutLoginComponent.vue';

import store from '@/store';
import { UserIdentityModel } from '@/models/file-entities.model';

import { AppNavLinks, firstView } from '@/business/settings';

export const layoutLoginRoutes = {
  path: '/login',
  name: 'Layout Login',
  component: RepsolLayoutLoginComponent,
  beforeEnter: (to: any, from: any, next: any) => {
    if (to.query?.loggedOut === 'true' || sessionStorage.getItem('loggedOut') === 'true') {
      localStorage.removeItem('vuex');
      (store as any).commit('userIdentity/CLEAR_USER_IDENTITY');
      return next();
    }

    const userIdentity = (store.state as any).userIdentity
      .userIdentity as UserIdentityModel;
    if (!userIdentity?.tokenExpirationDate) return next();
    const tokenExpires = new Date(userIdentity.tokenExpirationDate);
    if (tokenExpires > new Date()) {
      const navigateTo = AppNavLinks.find((item) => item.name === firstView);
      next(navigateTo?.path);
    } else {
      return next();
    }
  },
  meta: {
    title: '',
    isPublic: true,
  },
  children: [],
};
